import azDate from '@azinformatica/loki/src/filters/az-date'

const filter = (dataDe, dataAte) => {
	return `${azDate(dataDe, 'DD/MM/YYYY')} - ${azDate(dataAte, 'DD/MM/YYYY')}`
}

export default filter
